import PropTypes from 'prop-types'
import React from 'react'
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import './index.css'

export default function Modal (props) {
  const {
    children,
    initialFocusRef,
    onClose,
    header,
    adjustToContentHeight,
    footer
  } = props
  const snapPoints = (params) => {
    const min = params.maxHeight - (params.maxHeight * 0.2)
    return [min]
  }

  let defaultSnap
  if (!adjustToContentHeight) {
    defaultSnap = (params) => params.maxHeight - (params.maxHeight * 0.2)
  }

  return (
    <BottomSheet
      onDismiss={onClose}
      snapPoints={snapPoints}
      defaultSnap={defaultSnap}
      initialFocusRef={initialFocusRef}
      open
      header={header}
      footer={footer}
    >
      {children}
    </BottomSheet>
  )
}

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  onClose: PropTypes.func
}
